var render = function render(){var _vm=this,_c=_vm._self._c;return _c('details',{class:_vm.classes,attrs:{"open":_vm.open}},[_c('summary',{staticClass:"ui-details__summary",on:{"click":_vm.onSummaryClick}},[_vm._t("summary")],2),_c('div',{staticClass:"ui-details__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }